var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebdoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder_Web",
    "data-name": "Folder Web"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42 33v-15a3.9989 3.9989 0 0 0 -4-4h-15.68a2.9916 2.9916 0 0 1 -2.6-1.51l-1.99-3.47a3.9957 3.9957 0 0 0 -3.47-2.02h-10.26a3.9989 3.9989 0 0 0 -4 4v22a3.9989 3.9989 0 0 0 4 4h4a13 13 0 0 1 26 0h12a3.9989 3.9989 0 0 1 -4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 0h-35a4 4 0 0 0 -4 4v1h9.26a6.0236 6.0236 0 0 1 5.21 3.02l1.98 3.48a1.0035 1.0035 0 0 0 .87.5h15.68a6 6 0 0 1 6 6v15a2 2 0 0 0 4 0v-29a4 4 0 0 0 -4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 26.1013v4.9494h3.3877a16.5447 16.5447 0 0 0 -1.63-4.6362 10.8972 10.8972 0 0 0 -1.7577-.3132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.0507 36.0507h3.965c.03-1.03.107-2.0329.2254-3h-3.4771a10.8962 10.8962 0 0 0 -.7133 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0158 36.0507h3.9842v-3h-3.7425c-.1263.9631-.2096 1.9674-.2417 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 36.0507h3.972c-.0326-1.03-.1126-2.0341-.2406-3h-3.7314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5981 31.0507h3.4019v-4.9494a10.8948 10.8948 0 0 0 -1.7728.3172 16.4254 16.4254 0 0 0 -1.6291 4.6322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7509 41.0507h3.4851a10.8979 10.8979 0 0 0 .7133-3h-3.9769c-.0305 1.0257-.1016 2.03-.2215 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 48a10.89 10.89 0 0 0 1.7437-.31 16.5542 16.5542 0 0 0 1.6414-4.64h-3.3851z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2469 47.6879a10.8937 10.8937 0 0 0 1.7531.3121v-4.9493h-3.3792a16.7483 16.7483 0 0 0 1.6261 4.6372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5345 27.518a11.0712 11.0712 0 0 0 -3.7421 3.5327h2.7639a22.2476 22.2476 0 0 1 .9782-3.5327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.2076 31.0507a11.0734 11.0734 0 0 0 -3.7635-3.5457 22.1049 22.1049 0 0 1 .9911 3.5457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.03 38.0507h-3.9793a10.8979 10.8979 0 0 0 .7133 3h3.4823c-.1208-.9692-.1854-1.977-.2163-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4424 46.5973a11.0729 11.0729 0 0 0 3.7652-3.5466h-2.7788a22.36 22.36 0 0 1 -.9864 3.5466z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7924 43.0507a11.0738 11.0738 0 0 0 3.7727 3.5512 22.4914 22.4914 0 0 1 -.9947-3.5512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7563 33.0507c.1187.967.1853 1.9731.2153 3h3.9777a10.8962 10.8962 0 0 0 -.7133-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.2728 41.0507h3.7272v-3h-3.9706a29.9331 29.9331 0 0 0 .2434 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 41.0507h3.7278a30.01 30.01 0 0 0 .2448-3h-3.9726z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdoc);
export default __webpack_public_path__ + "static/media/webdoc.da037a13e9d57f7ceae1abd3a79d07cb.svg";
export { ForwardRef as ReactComponent };